const MainCategory = [
    {
        id: 3,
        name: "Accessories",
        value: "accessories",
        slug: "/accessories",
    },
    {
        id: 2,
        name: "Fragrance",
        value: "fragrance",
        slug: "/fragrance",
    },
        {
        id: 1,
        name: "Apparel",
        value: "apparel",
        slug: "/apparel",
    },
];
export default MainCategory;